module.exports = __webpack_public_path__ + "static/media/TrackingNumber.67ac95d5.svg";